import { ArrowRight, Mail } from "lucide-react";
import { useState } from "react";
import { apiRequest } from "../api";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setLoading(true);
    setMessage("");
    try {
      const response = await apiRequest<{ message: string }>("/api/auth/request-link", { method: "POST", body: JSON.stringify({ email }) });
      setMessage(response.message);
    } catch (failure) {
      setMessage(failure instanceof Error ? failure.message : "Could not request a sign-in link");
    } finally { setLoading(false); }
  }
  return <main className="auth-page"><section className="auth-panel"><div className="brand-mark"><span>SH</span></div><p className="eyebrow">Sidehop Operations</p><h1>Infrastructure control</h1><form onSubmit={submit}><label><span>Admin email</span><div className="input-with-icon"><Mail size={18} /><input type="email" autoComplete="email" required value={email} onChange={(event) => setEmail(event.target.value)} placeholder="name@example.com" /></div></label><button className="primary-button" type="submit" disabled={loading}>Send sign-in link<ArrowRight size={17} /></button></form>{message ? <p className="auth-message" role="status">{message}</p> : null}</section></main>;
}
